module.exports = __webpack_public_path__ + "img/rank.44bfde09.png";